export { default as StoreLocator } from './store-locator';
